import { useCallback, useRef } from 'react'

export function usePlayFullscreen() {
	const heroRef = useRef<HTMLDivElement>(null)

	const handleFullscreen = useCallback(() => {
		const element = heroRef.current

		if (!element) {
			return
		}

		if (document.fullscreenElement) {
			void document.exitFullscreen()
			return
		}

		void element.requestFullscreen()
	}, [])

	return { heroRef, handleFullscreen }
}
